import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';

@Component({
  selector: 'app-ver-becas-becario',
  templateUrl: './ver-becas-becario.component.html',
  styleUrls: ['./ver-becas-becario.component.css']
})
export class VerBecasBecarioComponent implements OnInit {


  dtOptionsReq: DataTables.Settings = {};
  public dtTriggerReq: Subject<any>;

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecBeca = []; public nombreBeca: string = ''; public vecAjustes: Array<any> = []; public chbAcepta: boolean = false; vecRequisito = []; public nombRequisito: string = '';
  private idBeca: number = 0; private perVigente: string = 'na'; private vecDataEstudiante: Array<any> = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private srvGeneral: recursosCompartido,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private ruta: Router) { }

  ngOnInit() {
    this.dtTriggerReq = new Subject<any>();
    this.dtOptionsReq[0] = this.tools.OpcionesTabla(10);

    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.nombreBeca = localStorage.getItem('nombBeca');
    this.cargarBecas(localStorage.getItem('tipoBeca'));
  }
  //FUNCION QUE CARGA TODAS LAS BECAS
  async cargarBecas(tipo) {
    this.perVigente = 'na'; this.vecBeca = []; this.vecDataEstudiante = [];
    this.cargando.abrir();
    //OBTENER EL PERIODO VIGENTE
    const resPer = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(10, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPer.success) {
      this.perVigente = resPer.carrera[0].strCodigo;
      //OBTENER LA INFORMACION DE LA MATRICULA DE LOS ESTUDIANTES
      this.vecDataEstudiante = await this.srvGeneral.verDataMatricula('na', this.perVigente, localStorage.getItem('ciUsuario'));
    }
    else
      this.alerti.warning('No existe ´período académico vigente');
    //OBTENER LAS BECAS DISPONIBLES
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(10, tipo, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objBeca of res.becas) {
        this.vecBeca.push({
          codigo: objBeca.idBeca, nombre: objBeca.strNombre, detalle: objBeca.strDescripcion, admite: objBeca.intAdmite
        });
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();

  }
  //FUNCION QUE ABRE LOS REQUISITOS DE UN TIPO DE BECA SELECCIONADO
  verRequisitos(tipo, modal) {
    this.dtTriggerReq = new Subject<any>();
    this.dtOptionsReq[0] = this.tools.OpcionesTabla(10);

    this.mr = this.modalService.open(modal);

    this.nombRequisito = tipo['nombre'];
    var table2 = $('#tblRequisito').DataTable({
      destroy: true
    });
    table2.destroy();
    this.verListaRequisitos(tipo['codigo']);
  }
  async verListaRequisitos(tipo) {
    this.vecRequisito = []; var cont = 1;
    const resEsp = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(1, tipo, this.perVigente, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEsp.success) {
      for (let i in resEsp.especifico) {
        this.vecRequisito.push({ num: cont, tipo: 'Específico', nombre: resEsp.especifico[i]['strNombre'] });
        cont++;
      }
    }

    const resGen = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(3, this.perVigente, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGen.success) {
      for (let i in resGen.especifico) {
        this.vecRequisito.push({ num: cont, tipo: 'General', nombre: resGen.especifico[i]['reqNombre'] });
        cont++;
      }
    }
    this.dtTriggerReq.next();
  }
  //FUNCION QUE ABRE EL MODAL CON LOS TERMINOS Y CONDICIONES
  async aplicaBeca(datoBeca, modal) {
    this.vecAjustes = [];
    this.vecAjustes.push({ datFecha: '', intActualizar: '', intAdmite: '', intPersona: '', intTipoBeca: '', strCondiciones: '', strCorreoReqSubir: '', strPeriodo: '' });

    if (this.perVigente == 'na')
      this.alerti.error('No existe un período vigente a la fecha');
    else {
      if (this.vecDataEstudiante[0].banMatricula) {

        //DETERMINAR SI TIENE UN POSTULACION VIGENTE
        const resPostula = await new Promise<any>(resolve =>
          this.srvSelect.gestionPostulantes(7, this.vecDataEstudiante[0].matricula[0].codEstudiante, this.perVigente, this.vecDataEstudiante[0].matricula[0].codCarrera, 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (!resPostula.success) {
          //DETERMINAR SI TIENE REGISTRADA EN EL PERIODO
          const resPosBeca = await new Promise<any>(resolve =>
            this.srvSelect.gestionPostulantes(12, this.perVigente, this.vecDataEstudiante[0].matricula[0].cedEstudiante, datoBeca['codigo'], 'na').subscribe(translated => {
              resolve(translated)
            }));
          if (!resPosBeca.success) {
            //OBTENER LOS AJUSTES PARA LA BECA
            const resAjuste = await new Promise<any>(resolve =>
              this.srvSelect.gestionBecas(14, datoBeca.codigo, this.perVigente, 'na').subscribe(translated => {
                resolve(translated)
              }));
            if (resAjuste.success) {
              if (resAjuste.becas[0].intAdmite == 1) {
                if (resAjuste.becas[0].vigentePostula > 0) {
                  localStorage.setItem('localIdBeca', datoBeca['codigo']);
                  localStorage.setItem('localNomBeca', datoBeca['nombre']);
                  this.vecAjustes = resAjuste.becas;
                  this.mr = this.modalService.open(modal);
                  this.idBeca = datoBeca['codigo'];
                }
                else
                  this.alerti.error('La fecha de postulación es menor a la fecha actual');
              }
              else
                this.alerti.error('Este tipo de beca no admite postulantes');
            }
            else
              this.alerti.error('Este tipo de beca no se encuentra disponible actualmente');
          }
          else
            this.alerti.error('Usted ya tiene una postulación para esta beca');
        }
        else
          this.alerti.error('Usted tiene una postulación vigente. Para revisar el estado de la misma diríjase a la opción de Mis Postulaciones');
      }
      else
        this.alerti.error('Usted no tiene matrícula vigente a la fecha');
    }
  }
  //ABRE EL FORMULARIO PARA EL REGISTRO DE REQUISITOS
  async aceptaTerminos() {
    if (this.chbAcepta) {
      this.agregarPostulacion(12, this.vecDataEstudiante[0].matricula[0].codEstudiante, this.idBeca, 3, 3, 'PENDIENTE', '', this.perVigente,
        this.vecDataEstudiante[0].matricula[0].codCarrera, this.vecDataEstudiante[0].matricula[0].codFacultad,
        this.vecDataEstudiante[0].matricula[0].codNivel, this.vecDataEstudiante[0].matricula[0].cedEstudiante, this.vecDataEstudiante[0].promedioAnterior, '', this.perVigente);
    }
    else
      this.alerti.error('Debe aceptar los términos y condiciones antes de continuar');
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
  //FUNCION QUE REGISTRA UNA POSTULACION DE UN BECARIO
  agregarPostulacion(opc, dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, dato14) {
    this.srvInsert.ingresoGestionBecas(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, this.perVigente, opc).subscribe(res => {
      if (res['becas'] == 'true') {
        this.cerrarModal();
        //this.ruta.navigate(["/becario/postulaBecas"]);
        this.verUltimaPostulacion(dato11, dato7, 3, dato2);
      }
      else
        this.alerti.error("No se puede agregar la postulación. Intente más tarde.");
    });
  }
  //OBTENER EL ID DE LA POSTULACION PARA LA CARGA DE ARCHIVOS
  async verUltimaPostulacion(dato1, dato2, dato3, dato4) {
    const resPostula = await new Promise<any>(resolve =>
      this.srvSelect.gestionPostulantes(11, dato1, dato2, dato3, dato4).subscribe(translated => {
        resolve(translated)
      }));
    if (resPostula.success) {
      localStorage.setItem('localBecaIdA', resPostula.postula[0].intIdAplica)
      this.ruta.navigate(["/becario/postulaBecas"]);
    }
  }
}
